import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/SophiaFranklin_Pet/subs.vtt';
import poster from '@/static/assets/reviews/SophiaFranklin_Pet/video.jpg';

export const SophiaFranklin: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet, ReviewProduct.All],
  reviewerName: 'Sophia',
  videoUrl: `${ASSETS_URL}/pet/SophiaFranklin_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
